import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'src/hook/useAppSelector';
import { selectIsAuthenticated, selectIsLoading } from 'src/store/slice/authSlice';
import { Spinner } from '@amzn/awsui-components-react';
import { usePermissions } from 'src/hooks/usePermissions';

interface ProtectedRouteProps {
    children: React.ReactNode;
    check?: (perms: ReturnType<typeof usePermissions>) => boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, check }) => {
    const location = useLocation();
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const isLoading = useAppSelector(selectIsLoading);
    const perms = usePermissions();

    if (isLoading) {
        return <Spinner size="big" />;
    }

    if (!isAuthenticated) {
        sessionStorage.setItem('redirectUrl', location.pathname + location.search);
        return <Navigate to="/" replace />;
    }

    if (check && !check(perms)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
